(() => {
  function initializeHeldLight(root) {
    if (!root || root.dataset.ntwHeldLightReady === "true") return;
    root.dataset.ntwHeldLightReady = "true";

    const neonCopy = root.querySelector("[data-ntw-neon-copy]");
    if (neonCopy) {
      let neonIsVisible = true;
      const updateNeonState = () => {
        neonCopy.classList.toggle("is-neon-active", neonIsVisible && document.visibilityState === "visible");
      };

      if ("IntersectionObserver" in window) {
        const neonObserver = new IntersectionObserver(([entry]) => {
          neonIsVisible = entry.isIntersecting;
          updateNeonState();
        }, { threshold: 0.15 });
        neonObserver.observe(neonCopy);
      } else {
        updateNeonState();
      }
      document.addEventListener("visibilitychange", updateNeonState);
    }

    const dialog = root.querySelector("[data-ntw-concept-dialog]");
    if (!dialog) return;

    let lastTrigger = null;

    function closeDialog() {
      if (dialog.open) dialog.close();
    }

    root.querySelectorAll("[data-ntw-concept-open]").forEach((trigger) => {
      trigger.addEventListener("click", () => {
        const card = trigger.closest("[data-ntw-concept-card]");
        if (!card) return;

        lastTrigger = trigger;
        const sourceMark = card.querySelector("[data-ntw-concept-mark]");
        const targetMark = dialog.querySelector("[data-ntw-dialog-mark]");
        const sourcePhoto = card.querySelector("[data-ntw-concept-photo]");
        const sourceImage = sourcePhoto?.querySelector("img");
        const targetPhoto = dialog.querySelector("[data-ntw-dialog-art]");

        targetMark.replaceChildren(...[...sourceMark.children].map((node) => node.cloneNode(true)));
        if (sourceImage) targetPhoto.style.backgroundImage = `url("${sourceImage.currentSrc || sourceImage.src}")`;
        dialog.querySelector("[data-ntw-dialog-category]").textContent = card.querySelector("[data-ntw-concept-category]").textContent;
        dialog.querySelector("[data-ntw-dialog-name]").textContent = card.querySelector("[data-ntw-concept-name]").textContent;
        dialog.querySelector("[data-ntw-dialog-copy]").textContent = card.querySelector("[data-ntw-concept-copy]").textContent;
        dialog.querySelector("[data-ntw-dialog-execution]").textContent = card.querySelector("[data-ntw-concept-execution]").textContent;

        if (typeof dialog.showModal === "function" && !dialog.open) dialog.showModal();
      });
    });

    dialog.querySelectorAll("[data-ntw-dialog-close]").forEach((button) => button.addEventListener("click", closeDialog));
    dialog.addEventListener("click", (event) => { if (event.target === dialog) closeDialog(); });
    dialog.addEventListener("close", () => { if (lastTrigger) lastTrigger.focus(); });

    function initializeCarousel(carousel, viewportSelector, previousSelector, nextSelector) {
      const viewport = carousel?.querySelector(viewportSelector);
      const previousButton = carousel?.querySelector(previousSelector);
      const nextButton = carousel?.querySelector(nextSelector);

      if (viewport && previousButton && nextButton) {
        const updateControls = () => {
          const maximumScroll = Math.max(0, viewport.scrollWidth - viewport.clientWidth);
          previousButton.disabled = viewport.scrollLeft <= 2;
          nextButton.disabled = viewport.scrollLeft >= maximumScroll - 2;
        };

        const scrollCarousel = (direction) => {
          viewport.scrollBy({ left: direction * viewport.clientWidth * 0.8 });
        };

        previousButton.addEventListener("click", () => scrollCarousel(-1));
        nextButton.addEventListener("click", () => scrollCarousel(1));
        viewport.addEventListener("scroll", updateControls, { passive: true });
        if ("ResizeObserver" in window) {
          new ResizeObserver(updateControls).observe(viewport);
        }
        updateControls();
      }
    }

    initializeCarousel(
      root.querySelector("[data-ntw-project-carousel]"),
      "[data-ntw-project-viewport]",
      "[data-ntw-project-prev]",
      "[data-ntw-project-next]"
    );
  }

  function initializeAll(scope = document) {
    scope.querySelectorAll("[data-ntw-held-light]").forEach(initializeHeldLight);
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", () => initializeAll());
  } else {
    initializeAll();
  }

  document.addEventListener("shopify:section:load", (event) => initializeAll(event.target));
})();
